



































import {
  defineComponent,
  onMounted,
  onUnmounted,
  ref
} from '~/utils/nuxt3-migration'
import { Tooltip } from 'floating-vue'
import { ciTimes } from '~/icons/source/regular/times'

const breakpointLgScreen = 992 // lg: leaving this here to be available on search

export default defineComponent({
  props: {
    title: {
      type: String,
      default: null
    },
    hideCloseButton: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Tooltip
  },
  setup() {
    const disablePositioning = ref(false)
    let observer: ResizeObserver | null = null

    onMounted(() => {
      if (!process.client || !('ResizeObserver' in window)) return

      observer = new ResizeObserver(() => {
        disablePositioning.value = window.innerWidth < breakpointLgScreen
      })

      observer.observe(document.body)
      // Initial check
      disablePositioning.value = window.innerWidth < breakpointLgScreen
    })

    onUnmounted(() => {
      if (observer) {
        observer.disconnect()
      }
    })

    return {
      ciTimes,
      disablePositioning
    }
  }
})
